import { Injectable } from "@angular/core";
import {
	PostResponse,
	ProductVersionJaiceDetails
} from "@data/course";
import { ServiceResponse } from "@data/response";
import { API } from "@service/system/api.service";
import { ResponseHandler } from "@service/system/responseHandler.service";
import { Observable } from "rxjs";

const API_URL = API.API_URL;

@Injectable({
	providedIn: "root"
})
export class CourseJaiceService {
	private _coursesURL = `${API_URL}/course`;

	constructor(private responseHandler: ResponseHandler) {}

	GetProductVersionJaiceDetails(pvItemID: string): Observable<ServiceResponse<ProductVersionJaiceDetails[]>> {
		return this.responseHandler.httpGet<ProductVersionJaiceDetails[]>(`${this._coursesURL}/${pvItemID}/jaice/find`);
	}

	setCourseVersionJAICEDetails(cvItemID: string, body: string): Observable<ServiceResponse<PostResponse>> {
		return this.responseHandler.httpPost<PostResponse>(`${this._coursesURL}/${cvItemID}/jaice/set`, body);
	}
}
